import KanbanCustomizationSettings from './KanbanCustomizationSettings';
export default KanbanCustomizationSettings;
